export default "__VITE_ASSET__DKNN$b32__"